enum NewWordStatus {
    New = 1,
    Approved = 2,
    Ignored = 3,
}

export default NewWordStatus;
